import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { APP_VERSION } from './utils/localStorage';

window.addEventListener('beforeunload', () => {
    document.cookie = `${APP_VERSION}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
});

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
